import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { Skeleton, SkeletonText } from "@caspeco/casper-ui-library.components.skeleton"; // Antag att detta finns
import { ThemeSpaceVariable } from "@caspeco/casper-ui-library.base-ui.theme";

const FieldSkeleton = () => <Skeleton height="40px" borderRadius="8px" />;

export const DetailsWithPaymentFormSkeleton = () => {
    return (
        <form>
            <Flex direction="column" gap={ThemeSpaceVariable.Large} px={ThemeSpaceVariable.Medium}>
                <Flex direction="column" gap={ThemeSpaceVariable.Medium}>
                    <Skeleton height="150px" borderRadius="8px" />
                    <Skeleton height="60px" borderRadius="8px" />
                    <SkeletonText mt="4" noOfLines={4} spacing="4" skeletonHeight="2" />
                    <FieldSkeleton />
                    <FieldSkeleton />
                    <FieldSkeleton />
                    <FieldSkeleton />
                    <FieldSkeleton />
                    <FieldSkeleton />
                    <FieldSkeleton />
                </Flex>
                <Skeleton height="80px" borderRadius="8px" />
                <Skeleton height="40px" borderRadius="8px" />
                <Flex direction="column" gap={ThemeSpaceVariable.Medium}>
                    <Skeleton height="40px" borderRadius="8px" />
                    <Skeleton height="20px" width="60%" borderRadius="4px" />
                </Flex>
            </Flex>
        </form>
    );
};
